import { FC } from "react";
import { Message } from "../../../types";
import Heading from "../../Common/Heading";
import { StyledWrap, StyledContent } from "./style";
import { formatPlainText } from "../../../utils/methods";

type Props = {
  message: Message;
};

const MailBody: FC<Props> = ({ message }) => {
  return (
    <StyledWrap>
      <Heading as="h5" mb="30px">
        {message.Subject}
      </Heading>
      {/* <Heading mb="0px" fontWeight={600}>
        Ms. Katherine Lumaad
      </Heading>
      <Text as="span" color="text3">
        CompanyName, Inc.
      </Text>
      <Text color="text3">San Francisco, CA, United States</Text> */}
      <StyledContent>{formatPlainText(message.Text)}</StyledContent>
    </StyledWrap>
  );
};

export default MailBody;
